module.exports = __webpack_public_path__ + "img/8.51364467.png";